import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

// Current weekly master code for every SALTO facility.
export async function getMasters(language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/saltotestcodes/masters",
      language,
      timeZone,
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the salto master codes: ${e}`);
    return {
      success: false,
    };
  }
}

// Force an immediate rotation of the master code for a single facility
// (bootstrap a facility, or invalidate a leaked code on demand).
export async function rotateMaster(facilityId, language, timeZone) {
  try {
    const data = await wsRequestPost(
      "/admin/saltotestcodes/rotate-master",
      language,
      timeZone,
      null,
      { facilityId }
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to rotate the master code for facility ${facilityId}: ${e}`);
    return {
      success: false,
      message: e
    };
  }
}

// Rotate the master code for every SALTO facility at once (initial bootstrap).
export async function rotateAllMasters(language, timeZone) {
  try {
    const data = await wsRequestPost(
      "/admin/saltotestcodes/rotate-all-masters",
      language,
      timeZone,
      null,
      null
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to rotate all the salto master codes: ${e}`);
    return {
      success: false,
      message: e
    };
  }
}
